module.exports = {"513224100":"进安镇","513224101":"川主寺镇","513224102":"青云镇","513224103":"毛儿盖镇","513224104":"镇江关镇","513224105":"红土镇","513224106":"小河镇","513224201":"十里回族乡","513224203":"安宏乡","513224207":"镇坪乡","513224208":"岷江乡","513224209":"大姓乡","513224210":"白羊乡","513224213":"小姓乡","513224214":"燕云乡","513224219":"黄龙乡","513224221":"下八寨乡","513224401":"松潘林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513224.json
// module id = 2533
// module chunks = 0